/*
 * File: 会议详情
 * File Created: 2021-05-13 10:14:21 am
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-09-10 7:36:23 pm
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

<template>
  <div class="meeting-detail" :style="{'min-height': isPC ? '570px' : '0'}">
    <!-- 语言切换 -->
    <div class="top">
      <language-selector></language-selector>

      <!-- 会议取消提醒 -->
      <meeting-canceled-tips v-if="meetingInfo.meetingStatus == 6 && meetingInfo.endType === 3">
      </meeting-canceled-tips>

      <!-- 会议信息卡片 -->
      <meeting-fixed v-if="fixed" v-bind="meetingInfo"></meeting-fixed>
      <meeting-info v-else v-bind="meetingInfo"> </meeting-info>

      <!-- 按钮区域 -->
      <div v-if="!(meetingInfo.meetingStatus == 6 && meetingInfo.endType === 3)" class="actions-container">
        <div class="actions" :style="{'margin-top': meetingInfo.secure !== 1 ? '35px' : '25%'}">
          <div class="label">
            {{ $t("meeting.chinaRecommend") }}
          </div>
          <mx-button type="info" block @click="openInMission">
            {{ $t("meeting.openInMission") }}
          </mx-button>
        </div>
        <!-- <div class="actions" v-if="meetingInfo.secure !== 1 && meetingType === 'TM'">
          <div class="label">
            {{ $t("meeting.outsideRecommend") }}
          </div>
          
        </div> -->
        <div class="actions" v-if="!(meetingInfo.meetingStatus == 6 && meetingInfo.endType === 3) && meetingInfo.secure !== 1">
          <div class="label">
            {{ $t("meeting.otherToMeeting") }}
          </div>
          <!-- zoom入会模块 -->
          <mx-button
            v-if="meetingType === 'zoom'"
            type="info"
            block
            :general="true"
            @click="openInUMeeting"
            style="margin-bottom: 10px;"
          >
            {{ $t("meeting.openInMideaMeeting") }}
          </mx-button>
          <!-- 腾讯入会模块 -->
          <!-- 腾讯会议客户端入会 -->
          <mx-button
            v-if="meetingType === 'TM'"
            type="info"
            block
            :general="true"
            style="margin-bottom: 10px;"
            @click="openInWXMeeting"
          >
            {{ $t("meeting.openInWXMeeting") }}
          </mx-button>
          <!-- 小程序入会 -->
          <mx-button
            v-if="meetingType === 'TM' && wxImgUrl"
            type="info"
            block
            @click="openInWXApplet"
            :general="true"
            style="margin-bottom: 10px;"
            class="label_btn"
          >
            {{ $t("meeting.openInWXApplet") }}
          </mx-button>
          <mx-button type="info" block :general="true" @click="confirmJoin" v-if="isPC">
            {{ $t("meeting.joinMeetingInBrowser") }}
          </mx-button>
          <div class="tips" v-if="isPC">
            <span class="tips-start">*</span
            >{{ $t("meeting.browserMeetingTips") }}
          </div>
        </div>
      </div>
    </div>

    <div class="bottom">
      <div class="downLoad-buttomList" :style="{'justify-content': meetingInfo.secure !== 1 ? 'space-between' :'space-around'}">
        <a :href="toDownloadMX" target="_blank">{{ $t("meeting.downloadMX") }}</a>
        <div v-if="meetingInfo.secure !== 1">
          <a
            :href="toDownloadTXMeeting"
            @click="todownTXM"
            target="_blank"
            v-if="meetingType === 'TM' && $i18n.locale === 'zh-CN'"
            >{{ $t("meeting.downloadTXMeeting") }}</a
          >
          <a
            :href="toDownloadVooV"
            @click="todownTXM"
            target="_blank"
            v-if="meetingType === 'TM' && $i18n.locale !== 'zh-CN'"
            >{{ $t("meeting.downloadTXMeeting") }}</a
          >
          <a :href="toDownloadMX" @click="todownMXM" target="_blank" v-if="meetingType === 'zoom'">{{
            $t("meeting.downloadMideaMeeting")
          }}</a>
        </div>
      </div>
      <span class="actions-buttom">
        <a :href="toLink" target="_blank" @click="toReadingGuideline">{{ $t("meeting.readingGuideline") }}</a>
      </span>
    </div>
    <!-- 微信浏览器提醒 -->
    <!-- <wechat-tips v-if="!isWechat" :isShow="!showWechatTips"> </wechat-tips> -->
    <!-- <wechat-tips> </wechat-tips> -->
    <!-- 确认弹窗 -->
    <van-dialog
      class="confirm-dialog"
      v-model="confirmDialogVisible"
      show-cancel-button
      :confirm-button-text="$t('common.ok')"
      :cancel-button-text="$t('common.stillUse')"
      width="270"
      @cancel="joinMeetingOnBrowser"
    >
      <span>{{ $t("meeting.browserMeetingTips") }}</span>
    </van-dialog>
  </div>
</template>

<script>
import MxButton from "@/components/mx-button";
import LanguageSelector from "@/components/language-selector";
import MeetingInfo from "@/components/meeting-info";
import MeetingFixed from "@/components/meeting-info-fixed";
// import WechatTips from "@/components/wechat-tips";
import MeetingCanceledTips from "@/components/meeting-canceled-tips";
// import axios from "axios";
// import jsonp from "jsonp";

import {
  isPC,
  isWechat,
  isMX,
  queryURLParams,
  genrateMissionOpenUrl,
  genrateMideaMeetingOpenUrl,
  getMissionDownloadUrl,
  getMideaMeetingDownloadUrl,
  genrateMissionOpenWXUrl,
} from "@/utils";
import { mapGetters, mapMutations } from "vuex";
import { Dialog } from "vant";
import { OPEN_MISSION, OPEN_MIDEA_MEETING } from "./constant";
import Config from "@/config";

export default {
  name: "meeting-detail",
  components: {
    MxButton,
    LanguageSelector,
    MeetingInfo,
    MeetingFixed,
    MeetingCanceledTips,
    // WechatTips,
    VanDialog: Dialog.Component,
  },
  data() {
    return {
      meetingInfo: {},
      isPC: isPC(),
      isWechat: isWechat(),
      isMX: isMX(),
      showWechatTips: false,
      confirmDialogVisible: false,
      notStartDialogVisible: false,
      openType: undefined,
      wxImgUrl: "",
      showWXCode: false,
      meetingType: "zoom", // 当前会议类型：zoom、TM(腾讯会议)
      fixed: 0,
    };
  },
  computed: {
    ...mapGetters(["browserMeetingUrl"]),
    meetingUuid() {
      return this.$route.query.meetingUuid;
    },
    downloadInfo() {
      let obj = {};
      console.log("type---------", this.openType);
      if (this.openType === OPEN_MISSION) {
        obj.url = getMissionDownloadUrl();
        obj.text = this.$t("meeting.donwloadMissionImed");
      }
      if (this.openType === OPEN_MIDEA_MEETING) {
        obj.url = getMideaMeetingDownloadUrl();
        obj.text = this.$t("meeting.downloadMideaMeeting");
      }
      return obj;
    },
    toLink() {
      const { toLinkZoom, toLinkTM, toGaoAnLink } = Config
      if(this.meetingInfo.secure === 1) {
        return toGaoAnLink
      }
      // 判断当前环境
      const langObj = {
        "zh-CN": this.isPC ? toLinkZoom.toPCLinkZH : toLinkZoom.toMobileLinkZH,
        "ja-JP": this.isPC ? toLinkZoom.toPCLinkJP : toLinkZoom.toMobileLinkJP,
        "en-US": this.isPC ? toLinkZoom.toPCLinkEN : toLinkZoom.toMobileLinkEN,
      };
      const TMObj = this.isPC ? toLinkTM.toMXBrowserLink : toLinkTM.toOtherBrowserLink
      return this.meetingType === 'TM' ? TMObj : langObj[this.$i18n.locale]
    },
    toDownloadMX() {
      return Config.toDownloadMX;
    },
    toDownloadTXMeeting() {
      return Config.toDownloadTXMeeting;
    },
    toDownloadVooV() {
      return Config.toDownloadVooV;
    },
    currentResource() {
      return queryURLParams(location.href).resource || 0
    }
  },
  methods: {
    ...mapMutations(["setBrowserMeetingUrl"]),
    async getMeetingDetail() {
      // const resource = this.currentResource
      // console.log("location---", resource);
      try {
        // this.$toast.loading({ message: this.$t('common.loading') })
        const meetingInfo = await this.$_httpDispatch("meeting-detail", {
          params: {
            meetingUuid: this.meetingUuid,
          },
          headers: {
            "X-MX-MEETING-SUPPLIER-TYPE": this.currentResource == 1 ? "TM" : "zoom",
          },
        });
        if (meetingInfo.webUrl) {
          this.setBrowserMeetingUrl(meetingInfo.webUrl);
        }
        this.meetingInfo = meetingInfo;
        // 获取小程序
        // this.$toast.clear()
      } catch (error) {
        throw new Error(error);
      }
    },
    // 判断会议状态
    checkMeetingStatus() {
      let flag = true;
      // 1-已建立，2-入场中，3-已开始，4-清场中，5-已结束，6-已取消；
      const { meetingStatus } = this.meetingInfo;
      switch (meetingStatus) {
        case 1:
          flag = false;
          // this.notStartDialogVisible = true;
          Dialog({
            message: this.$t("meeting.notStart"),
            confirmButtonText: this.$t("common.ok"),
            confirmButtonColor: "#2496FF",
            width: "270px",
            className: "confirm-dialog",
          });
          break;

        case 5:
          flag = false;
          Dialog({
            message: this.$t("meeting.hasFinished"),
            confirmButtonText: this.$t("common.ok"),
            confirmButtonColor: "#2496FF",
            width: "270px",
            className: "confirm-dialog",
          });
          break;

        case 6:
          flag = false;
          Dialog({
            message: this.meetingInfo.endType === 3 ? this.$t("meeting.hasCanceled") : this.$t("meeting.hasFinished"),
            confirmButtonText: this.$t("common.ok"),
            confirmButtonColor: "#2496FF",
            width: "270px",
            className: "confirm-dialog",
          });
          break;

        default:
          break;
      }
      return flag;
    },
    // 美信入会
    async openInMission() {
      this.openType = OPEN_MISSION;
      // const locationHref = queryURLParams(location.href);
      this.$_dataRanger.send("click_button_mideaconnect", {
        module: "视频会议",
        page_eng_name: "page_transit",
        module_name1: "中转页",
        module_name2: "美信入会",
      });
      // 重新获取详情，判断目前状态
      await this.getMeetingDetail();
      await this.$nextTick();
      // 检测异常状态
      if (!this.checkMeetingStatus()) {
        return;
      }
      // 添加会议标识：0：默认zoom标识尚阳会议 1：TM表示腾讯会议
      const resource = this.currentResource
      let missionSchemeUrl = genrateMissionOpenUrl(
        this.meetingUuid,
        this.meetingInfo.secure,
        resource
      );
      console.log('跳转链接---', missionSchemeUrl)
      window.location.replace(missionSchemeUrl);
      this.$router.push({
        name: "mission",
        query: {
          meetingUuid: this.meetingUuid,
          secure: this.meetingInfo.secure || 0,
          type: "mx",
          resource: this.currentResource
        },
      });
    },
    // midea meeting入会
    async openInUMeeting() {
      this.openType = OPEN_MIDEA_MEETING;
      // 重新获取详情，判断目前状态
      await this.getMeetingDetail();
      await this.$nextTick();
      // 检测异常状态
      if (!this.checkMeetingStatus()) {
        return;
      }
      const { umeetUuid, secure, meetingNo } = this.meetingInfo;
      let mideaMeetingSchemeUrl = genrateMideaMeetingOpenUrl(
        umeetUuid,
        meetingNo
      );
      window.location.replace(mideaMeetingSchemeUrl);
      this.$router.push({
        name: "mideaMeeting",
        query: {
          meetingUuid: this.meetingUuid,
          umeetUuid: umeetUuid,
          meetingNo,
          secure: secure || 0,
        },
      });
    },
    back() {
      window.history.go(-1);
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    // 腾讯会议客户端入会
    async openInWXMeeting() {
      const { meetingNo } = this.meetingInfo;

      this.openType = OPEN_MISSION;
      this.$_dataRanger.send("click_button_tencentmeeting", {
        module: "视频会议",
        page_eng_name: "page_transit",
        module_name1: "中转页",
        module_name2: "腾讯会议客户端入会",
      });
      // this.$_dataRanger.send("button_click", {
      //   module: "视频会议",
      //   sub_module: "会议中转页",
      //   page_name: "会议中转页",
      //   page_path: "会议中转页",
      //   element_content: "美信入会",
      // });
      // 重新获取详情，判断目前状态
      await this.getMeetingDetail();
      await this.$nextTick();
      // 检测异常状态
      if (!this.checkMeetingStatus()) {
        return;
      }
      // 添加会议标识：0：默认zoom标识尚阳会议 1：TM表示腾讯会议
      // const resource = 0;
      // const meetingCode = "5756942794";
      let missionSchemeUrl = genrateMissionOpenWXUrl(meetingNo);
      window.location.replace(missionSchemeUrl);
      this.$router.push({
        name: "mission",
        query: {
          meetingNo,
          type: "tx",
        },
      });
    },
    // 获取小程序图片
    async getWxXCXCode() {
      if(this.isPC) return
      // 重新获取详情，判断目前状态
      await this.getMeetingDetail();
      await this.$nextTick();
      if (!this.checkMeetingStatus()) {
        return;
      }
      console.log('会议--', this.meetingInfo)
      const data = await this.$_httpDispatch("get-wxpng", {
        params: {
          tencentMeetingId: this.meetingInfo.tencentMeetingId,
        },
      });
      console.log('data', data)
      if(data && data.meeting_wxacode_url) {
        this.wxImgUrl = data.meeting_wxacode_url;
      }
    },
    // 打开小程序图片
    openInWXApplet() {
      this.$emit("showWXFnc", this.wxImgUrl);
    },
    // 浏览器入会按钮
    confirmJoin() {
      this.openType = "";
      this.$_dataRanger.send("click_button_browser", {
        module_name1: "中转页",
        module_name2: "浏览器入会",
        page_name: "中转页",
        page_eng_name: 'page_transit',
      });
      this.joinMeetingOnBrowser();
      // this.confirmDialogVisible = true
    },
    // 确认进入浏览器入会
    async joinMeetingOnBrowser() {
      let url = this.browserMeetingUrl;
      // 重新获取详情，判断目前状态
      await this.getMeetingDetail();
      await this.$nextTick();
      if (!this.checkMeetingStatus()) {
        return;
      }
      if(this.currentResource == 1) {
        window.open('https://voovmeeting.com/r', "target");
        return
      } else if (!url) {
        const { webUrl } = await this.$_httpDispatch("meeting-detail", {
          params: {
            meetingUuid: this.meetingUuid,
          },
        });
        url = webUrl;
      }
      url && window.open(url, "target");
    },
    // 操作指引
    toReadingGuideline(){
      this.$_dataRanger.send("click_button_guide", {
        module: "视频会议",
        page_eng_name: "page_transit",
        module_name1: "中转页",
        module_name2: "查看操作指引",
      });
    },
    todownTXM(){
      this.$_dataRanger.send("click_button_tencentmeetingdownload", {
        module: "视频会议",
        page_eng_name: "page_transit",
        module_name1: "中转页",
        module_name2: "腾讯会议客户端下载",
      });
    },
    todownMXM(){
      this.$_dataRanger.send("click_button_mideaconnectdownload", {
        module: "视频会议",
        page_eng_name: "page_transit",
        module_name1: "中转页",
        module_name2: "美信下载",
      });
    }
  },
  async created() {
    console.log("window.PROJECT_CONFIG", window.PROJECT_CONFIG);
    const locationHref = queryURLParams(location.href);
    const fixed = locationHref.fixed || 0;
    console.log('fixed--', fixed)
    this.fixed = fixed
    if (this.currentResource == 1) {
      this.meetingType = "TM";
    } else {
      this.meetingType = "zoom";
    }
    await this.getMeetingDetail();
    if(this.meetingType === "TM") await this.getWxXCXCode();
  },
  mounted() {
    console.log("多语言环境：", this.$i18n.locale);
    // Dialog({
    //   message: this.isWechat ? 'isWechat true' : 'isWechat true',
    //   confirmButtonText: this.$t("common.ok"),
    //   confirmButtonColor: "#2496FF",
    //   width: "270px",
    //   className: "confirm-dialog",
    // });
    if (this.isWechat) {
      this.showWechatTips = true;
    }
  },
};
</script>

<style lang='less' scoped>
@confirm-text-color: #04a0ee;

.meeting-detail {
  // position: relative;
  // height: 100%;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  // min-height: 570px;
  max-height: 875px;
  .top, .bottom {
    width: 100%;
  }
  .top {
    flex: 1;
  }
  .actions-container {
    width: 100%;
    .actions {
      margin-top: 32px;
      .label {
        color: #5f5f5f;
        font-size: 14px;
        margin-bottom: 10px;
      }
      .label_btn {
        margin-top: 10px;
      }
      .tips {
        margin-top: 8px;
        font-size: 12px;
        color: #6a6a6a;
        &-start {
          color: #ff2b2b;
        }
      }
    }
  }
  .downLoad-buttomList {
    margin-top: 32px;
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #2496ff;
    line-height: 24px;
    a {
      color: #2496ff;
    }
  }
  .actions-buttom {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    // position: absolute;
    // bottom: 0;
    a {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #6a6a6a;
      line-height: 17px;
    }
  }
  .bottomTips {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #6a6a6a;
    line-height: 17px;
    margin-top: 32px;
  }
  .open-in-browser {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #6a6a6a;
    .blue {
      color: #0086ff;
      &:hover {
        cursor: pointer;
      }
    }
  }
  ::v-deep .confirm-dialog {
    .van-dialog {
      &__content {
        font-size: 16px;
        padding: 26px 23px 21px;
        color: rgba(0, 0, 0, 0.75);
        text-align: left;
      }
      &__footer {
        & > button:active {
          background: #e6e6e6;
          border-color: #e6e6e6;
        }
      }
      &__cancel {
        color: rgba(0, 0, 0, 0.45);
      }
      &__confirm {
        color: @confirm-text-color;
      }
    }
    &-center {
      .van-dialog__content {
        text-align: center;
        & > a {
          font-size: 14px;
          line-height: 22px;
          color: @confirm-text-color;
        }
      }
      .text {
        height: 22px;
        line-height: 22px;
      }
    }
  }
  /deep/ .van-nav-bar {
    background: #f2f2f2;
    .van-icon {
      color: #545454;
    }
    .van-nav-bar__left {
      padding-left: 0;
    }
  }
}
</style>
